import { isValidDateValue } from "@testing-library/user-event/dist/utils";
import { discountActions } from "./discount-slice";

export const GetDiscountAvailable = (email, userCounts, courseId) => {
  return async (dispatch) => {
    const getDiscountInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/discount/getDiscountAvailable`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            UserCounts: userCounts,
            Course: {
              id: courseId,
            },
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el descuento");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getDiscountInfo();
      if (response.result.errorCode === "OK") {
        
        dispatch(
          discountActions.setDiscount({
            discount: response.data,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          discountActions.setDiscount({
            discount: response.data,
          })
        );
      }
    } catch (error) {}
  };
};

export const VerifyDiscountCode = (email,discountCode, courseId) => {
  return async (dispatch) => {
    const getDiscountInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}aulaaba/discount/verifyDiscountCode`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            DiscountCode: discountCode,
            Course: {
              Id: courseId,
            },
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el descuento");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getDiscountInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          discountActions.setDiscount({
            discount: { isValid: true }
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          discountActions.setDiscount({
            discount: { isValid: false }
          })
        );
      }
    } catch (error) {}
  };
};